import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Globals } from '../global/globals';
import { DataExtractionPaper, DataExtractionStats } from '../dtos/data-extraction';

@Injectable({
  providedIn: 'root',
})
export class DataExtractionService {
  constructor(
    private httpClient: HttpClient,
    private globals: Globals,
  ) {}

  private getBaseUri(projectId: string): string {
    return `${this.globals.backendUri}/projects/${projectId}/data-extraction`;
  }

  getNextPaper(projectId: string): Observable<DataExtractionPaper | null> {
    return this.httpClient.get<DataExtractionPaper | null>(`${this.getBaseUri(projectId)}/next`);
  }

  getCurrentPaper(projectId: string): Observable<DataExtractionPaper | null> {
    return this.httpClient.get<DataExtractionPaper | null>(`${this.getBaseUri(projectId)}/current`);
  }

  complete(projectId: string, paperToProjectId: number): Observable<void> {
    return this.httpClient.post<void>(
      `${this.getBaseUri(projectId)}/${paperToProjectId}/complete`,
      {},
    );
  }

  skip(projectId: string, paperToProjectId: number): Observable<void> {
    return this.httpClient.post<void>(`${this.getBaseUri(projectId)}/${paperToProjectId}/skip`, {});
  }

  unlockPaper(projectId: string, paperToProjectId: number): Observable<void> {
    return this.httpClient.post<void>(
      `${this.getBaseUri(projectId)}/${paperToProjectId}/unlock`,
      {},
    );
  }

  getStats(projectId: string): Observable<DataExtractionStats> {
    return this.httpClient.get<DataExtractionStats>(`${this.getBaseUri(projectId)}/stats`);
  }

  getCompleted(projectId: string): Observable<DataExtractionPaper[]> {
    return this.httpClient.get<DataExtractionPaper[]>(`${this.getBaseUri(projectId)}/completed`);
  }

  getPaper(projectId: string, paperToProjectId: number): Observable<DataExtractionPaper> {
    return this.httpClient.get<DataExtractionPaper>(
      `${this.getBaseUri(projectId)}/${paperToProjectId}`,
    );
  }
}
